















import Vue from 'vue'
import Overlay from '@/common/components/Overlay.vue'
import Modal from '@/common/components/Modal.vue'

export default Vue.extend({
  components: {
    Overlay,
    Modal
  },
  props: {
   closeBtn: {
      type: Boolean,
      default: true
    },
    persistContents: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeModal(): void {
      this.$emit('closeModal')
    }
  }
})
